import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  FormControlLabel
} from "@mui/material";
import { useState } from "react";

const AddRole = () => {
  const navigate = useNavigate();

  const modules = [
    "Dashboard",
    "Manage Users",
    "Rewards & Offers Management",
    "Transactions & Loyalty Logs",
    "Promotion Management",
    "QR Code Management",
    "Store Management",
    "Feedback, Reports & Logs",
    "System Settings",
    "Notification & Communication Center",
    "Activity Logs",
    "Manage Sub-Admin",
    "Manage CMS Pages",
   
  ];

  const [permissions, setPermissions] = useState(
    modules.map((module, index) => ({
      id: index + 1,
      name: module,
      view: false,
      add: false,
      edit: false,
      delete: false
    }))
  );

  const handlePermissionChange = (id: number, field: string) => {
    setPermissions(prev =>
      prev.map(row =>
        row.id === id ? { ...row, [field]: !row[field as keyof typeof row] } : row
      )
    );
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Role</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {" "} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {" "} - <button onClick={() => navigate("/manage-subadmin/roles")}>Manage Roles</button>
          {" "} - Add Role
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_50">
              <label htmlFor="role">Role Name</label>
              <TextField id="role" placeholder="Enter Role Name" hiddenLabel fullWidth />
            </div>
          </div>

          <TableContainer className="table_container mt_20">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Module Name</TableCell>
                  <TableCell align="center">View</TableCell>
                  <TableCell align="center">Add</TableCell>
                  <TableCell align="center">Edit</TableCell>
                  <TableCell align="center">Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {permissions.map(row => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      {row.name.includes(" - ") ? (
                        <span style={{ paddingLeft: 20 }}>{row.name.split(" - ")[1]}</span>
                      ) : (
                        <strong>{row.name}</strong>
                      )}
                    </TableCell>
                    {["view", "add", "edit", "delete"].map(action => (
                      <TableCell align="center" key={action}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={Boolean(row[action as keyof typeof row])}
                              onChange={() => handlePermissionChange(row.id, action)}
                            />
                          }
                          name="check"
                          label=""
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRole;
